import axios from 'axios';

export async function saveCampaign({ userId, request, campaignId = '' }) {
    return await axios.post(`/vonq/${userId}/campaigns?campaignId=${campaignId}`, request)
        .then(({data}) => data);
}

export async function listCampaign({ userId, request, filterURI }) {
    return await axios.get(`/vonq/${userId}/campaigns/?${filterURI}`, request)
        .then(({data}) => data);
}

export async function cancelCampaign({userId, request, campaignId = ""}) {
    return await axios.put(`/vonq/${userId}/campaigns/${campaignId}/cancel`, request)
        .then(({data}) => data);
}

export async function cancelCampaignProduct({userId, request, campaignId = "", campaignItemId = ""}) {
    return await axios.put(`/vonq/${userId}/campaigns/${campaignId}/${campaignItemId}/cancel`, request)
        .then(({data}) => data);
}

export async function purchaseCampaign({userId, request, campaignId = ""}) {
    return await axios.post(`/vonq/${userId}/campaigns/${campaignId}/purchase`, request)
        .then(({data}) => data);
}

export async function savePostingRequirementsData({userId, campaignId, contractId, data}) {
    return await axios.post(`/vonq/${userId}/campaigns/${campaignId}/postingRequirements/${contractId}`, data)
        .then(({data}) => data);
}

export async function duplicateCampaign({userId, request, campaignId}){
    return await axios.post(`/vonq/${userId}/campaigns/${campaignId}/duplicate`)
        .then(({data}) => data);
}

